// components/common/loading/LoadingScreen.js
import React, { memo } from "react";
import styled from "styled-components";
import LoadingComponent from "./LoadingComponent";

const LoadingScreen = ({ loading, shaded, loading_msg }) => {
	return (
		<Container $loading={loading} $shaded={shaded}>
			<LoadingComponent loading_msg={loading_msg}/>
		</Container>
	);
};

const Container = styled.div`
	z-index: 3000;
	position: fixed;
	height: 100%;
	width: 100%;
	top: 0px;
	left: 0px;
	background-color: ${(props) =>
		props.$shaded ? "rgba(0,0,0,0.15)" : "transparent"};
	transition: opacity 0.3s ease-out;
	opacity: ${(props) => (props.$loading ? 1 : 0)};
	pointer-events: ${(props) => !props.$loading && "none"};
`;

export default memo(LoadingScreen);
